import { render, staticRenderFns } from "./ProductListSection.vue?vue&type=template&id=0c47f02c&"
import script from "./ProductListSection.vue?vue&type=script&lang=js&"
export * from "./ProductListSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports